module.exports = __webpack_public_path__ + "media/images/internal_server_error-2aa83a700b9b54ee35e266028a5b6b6f.svg";